module.exports = __webpack_public_path__ + "img/challenge-fullpair.8dfb54a0.png";